import React from 'react';

import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { IErrorOrderRef } from '@app/models/error';

import { useOrderRedirectQuery } from '@pages/Warehouses/pages/Single/components/WarehouseDocuments/components/DocumentDetailDrawer/components/OrderLink/hooks';

interface IProps {
  order: IErrorOrderRef;
}

export const OrderNumberLink: React.FC<IProps> = ({ order }) => {
  const warehousesT = useTranslation(NSKeys.warehouses);
  const { mutate, isLoading } = useOrderRedirectQuery(order.uid);

  return (
    <Button type="link" size="small" loading={isLoading} onClick={() => mutate()} style={{ padding: 0 }}>
      {warehousesT.t('unfinishedOrders.number', { num: order.num })}
    </Button>
  );
};
